import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { selectQuotationClosedBoxAccessories } from "app/containers/WorkOrder/redux/selector";
import { actions } from "app/containers/WorkOrder/redux/slice";
import { PlusIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { useStyles } from "../styles";
import { closedKey } from "./BoxStructureCards";

const COLUMNS = ["height", "location", "note"] as const;
const COLUMN_KEYS: Record<(typeof COLUMNS)[number], string> = {
  height: closedKey("FIELDS.HEIGHT"),
  location: closedKey("FIELDS.LOCATION"),
  note: closedKey("FIELDS.NOTE"),
};

const cellValue = (value: string, t: (key: string) => string) =>
  value.startsWith("QUOTES.") ? t(value) : value;

const STRIP_COLUMNS = { gridTemplateColumns: "48px 1fr 1fr 2fr" };

const AccessoriesTable = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const { tyingStrips } = useSelector(selectQuotationClosedBoxAccessories);

  return (
    <Box className={styles.tableBlock}>
      <Box className={styles.tableHeaderRow}>
        <Typography className={styles.tableTitle}>
          {t(closedKey("SECTIONS.TYING_STRIP"))}
        </Typography>
        <Button
          className={styles.addRowButton}
          variant="contained"
          color="primary"
          startIcon={<PlusIcon width={20} height={20} />}
          onClick={() => dispatch(actions.addQuotationClosedBoxTyingStripRow())}
        >
          {t(closedKey("TABLES.ADD_ROW"))}
        </Button>
      </Box>
      <Box className={styles.table}>
        <Box className={styles.tableHeadRowBasket} sx={STRIP_COLUMNS}>
          <Typography className={styles.tableHeadCell}>#</Typography>
          {COLUMNS.map((column) => (
            <Typography key={column} className={styles.tableHeadCell}>
              {t(COLUMN_KEYS[column])}
            </Typography>
          ))}
        </Box>
        {tyingStrips.map((row, index) => (
          <Box
            key={row.id}
            className={styles.tableBodyRowBasket}
            sx={STRIP_COLUMNS}
          >
            <Box className={`${styles.tableCell} ${styles.tableIndexCell}`}>
              {index + 1}
            </Box>
            {COLUMNS.map((column) => (
              <Box key={`${row.id}-${column}`} className={styles.tableCell}>
                <Typography className={styles.tableCellText}>
                  {cellValue(row[column], t)}
                </Typography>
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AccessoriesTable;
